module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Sortable","commonjs2":"sortablejs","commonjs":"sortablejs","amd":"sortablejs"}
// module id = 10
// module chunks = 0 2